import { useSheetPresence } from '../../../shared/hooks/use-sheet-presence';

import { TipsShareQrFullscreenContent } from './tips-share-qr-fullscreen-content';
import { TipsShareSheetShell } from './tips-share-sheet-shell';

type TipsShareSheetOverlayProps = {
  isOpen: boolean;
  onClose: () => void;
};

export function TipsShareSheetOverlay({
  isOpen,
  onClose,
}: TipsShareSheetOverlayProps) {
  const { handleCloseAnimationEnd, isMounted } = useSheetPresence(isOpen);

  if (!isMounted) {
    return null;
  }

  return (
    <TipsShareSheetShell
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={handleCloseAnimationEnd}
    >
      <TipsShareQrFullscreenContent onClose={onClose} />
    </TipsShareSheetShell>
  );
}
